'use client';

import { useId } from 'react';
import { OTPInput as OTPInputRoot, SlotProps } from 'input-otp';

import { cn } from '@/lib/utils';
import { InputErrors } from '@/shared/components/ui/inputs/input-errors';
import { InputProps } from '@/types/form/input-props';

export default function OtpInput({ value, onChange, errors, label, name }: InputProps) {
  const id = useId();
  const isError = !!errors?.length;

  return (
    <div className="*:not-first:mt-2">
      <OTPInputRoot
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        containerClassName="flex items-center gap-3 has-disabled:opacity-50"
        maxLength={6}
        render={({ slots }) => (
          <div className="flex gap-2 w-full">
            {slots.map((slot, idx) => (
              <Slot key={idx} {...slot} />
            ))}
          </div>
        )}
      />
      {isError && <InputErrors errors={errors} />}
    </div>
  );
}

function Slot(props: SlotProps) {
  return (
    <div
      className={cn(
        'border-input bg-background text-foreground flex flex-1 aspect-square items-center justify-center rounded-md border font-medium shadow-xs transition-[color,box-shadow] text-lg',
        { 'border-ring ring-ring/50 z-10 ring-[3px]': props.isActive },
      )}
    >
      {props.char !== null && <div>{props.char}</div>}
    </div>
  );
}
